<template>
    <div>Оплата прошла успешно...</div>
</template>

<script>
    export default {
        name: 'Payment',
        data() {
            return {
                error: {
                    exist: false,
                    message: '',
                },
            }
        },
        methods: {

        },
        mounted() {
            if (this.$route.params.status === 'success' && this.$store.state.order && this.$store.state.order.id && this.$store.state.order.id === this.$route.query.OrderId) {
                location.href = process.env.VUE_APP_HOST + '/payment-finished/' + '?OrderId=' + this.$route.query.OrderId + '&auth_token=' + this.$store.state.authToken;
            } else {
                this.error.exist = true;
                this.error.message = 'ошибка';
            }
        }
    }
</script>